import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=53dc6fcb&scoped=true"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=53dc6fcb&prod&lang=scss"
import style1 from "./Rooms.vue?vue&type=style&index=1&id=53dc6fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc6fcb",
  null
  
)

export default component.exports